/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */

// Angular
import { NgModule } from '@angular/core';
// NGC
import { NgcButtonsModule } from './ngc-buttons.module';
import { NgcContainerModule } from './ngc-container.module';
import { NgcDataModule } from './ngc-data.module';
import { NgcFileModule } from './ngc-file.module';
import { NgcInputsModule } from './ngc-inputs.module';
import { NgcLayoutModule } from './ngc-layout.module';
import { NgcMenusModule } from './ngc-menus.module';
import { NgcMessageModule } from './ngc-message.module';
import { NgcMiscModule } from './ngc-misc.module';
import { NgcOverlayModule } from './ngc-overlay.module';

/**
 * NGC Module
 */

export class NgcFrameworkModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [
        NgcButtonsModule,
        NgcContainerModule,
        NgcDataModule,
        NgcFileModule,
        NgcInputsModule,
        NgcLayoutModule,
        NgcMenusModule,
        NgcMessageModule,
        NgcMiscModule,
        NgcOverlayModule
    ],
    exports: [
        NgcButtonsModule,
        NgcContainerModule,
        NgcDataModule,
        NgcFileModule,
        NgcInputsModule,
        NgcLayoutModule,
        NgcMenusModule,
        NgcMessageModule,
        NgcMiscModule,
        NgcOverlayModule
    ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
